export function findIndexById<T extends { id: number }>(
  arr: T[],
  id: number
): number {
  return arr.findIndex((item) => item.id === id);
}
